/**
 * <fr-seo-text>: shows "Read more" only when the clamped body overflows; toggles aria-expanded + label.
 * Event: `fr:seo-text:toggle` (detail: { expanded }).
 */
class FrSeoText extends HTMLElement {
  connectedCallback() {
    this.body = this.querySelector('[data-fr-seo-body]');
    this.button = this.querySelector('[data-fr-seo-toggle]');
    if (!this.body || !this.button) return;
    this.button.addEventListener('click', this.toggle);
    this.measure();
    if ('ResizeObserver' in window) {
      this.ro = new ResizeObserver(() => this.measure());
      this.ro.observe(this.body);
    }
  }

  disconnectedCallback() {
    this.ro?.disconnect();
  }

  measure() {
    if (this.hasAttribute('data-expanded')) return;
    const overflows = this.body.scrollHeight - this.body.clientHeight > 2;
    this.button.hidden = !overflows;
  }

  toggle = () => {
    const expanded = !this.hasAttribute('data-expanded');
    this.toggleAttribute('data-expanded', expanded);
    this.button.setAttribute('aria-expanded', String(expanded));
    this.button.textContent = expanded ? this.button.dataset.labelLess : this.button.dataset.labelMore;
    this.dispatchEvent(new CustomEvent('fr:seo-text:toggle', { bubbles: true, detail: { expanded } }));
  };
}

if (!customElements.get('fr-seo-text')) customElements.define('fr-seo-text', FrSeoText);
